const state = {
    whatsappEdit: null,
    whatsappDelete: null
}
export default state